import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { clearDeviceToast } from '../../reducers/device.js';
import styles from './port-status-indicator.css';

// Non-blocking corner feedback:
//  - while the port is busy (upload / list fetch): a spinner + live message.
//  - after an event: a success/error toast that auto-dismisses.
const PortStatusIndicator = ({ portBusy, toast, onClearToast }) => {
    const timer = useRef(null);

    useEffect(() => {
        if (toast) {
            clearTimeout(timer.current);
            timer.current = setTimeout(
                () => onClearToast(toast.id),
                toast.kind === 'error' ? 5000 : 3000
            );
        }
        return () => clearTimeout(timer.current);
    }, [toast, onClearToast]);

    if (portBusy && portBusy.isPortBusy) {
        return (
            <div className={styles.container}>
                <span className={styles.spinner} />
                <span className={styles.message}>
                    {portBusy.label || portBusy.message || 'Working…'}
                </span>
            </div>
        );
    }

    if (toast) {
        const kindClass =
            toast.kind === 'error' ? styles.error : styles.success;
        return (
            <div className={`${styles.container} ${kindClass}`}>
                <span className={styles.icon}>
                    {toast.kind === 'error' ? '✕' : '✓'}
                </span>
                <span className={styles.message}>{toast.message}</span>
            </div>
        );
    }

    return null;
};

PortStatusIndicator.propTypes = {
    portBusy: PropTypes.shape({
        isPortBusy: PropTypes.bool,
        portBusyFor: PropTypes.string,
        message: PropTypes.string,
    }),
    toast: PropTypes.shape({
        kind: PropTypes.string,
        message: PropTypes.string,
        id: PropTypes.number,
    }),
    onClearToast: PropTypes.func,
};

const mapStateToProps = state => ({
    portBusy: state.scratchGui.device.portBusy,
    toast: state.scratchGui.device.toast,
});

const mapDispatchToProps = dispatch => ({
    onClearToast: id => dispatch(clearDeviceToast(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PortStatusIndicator);
